const Keys = {
  googleVision: "",
  vapid: "",
  firebase: "",
  ClientID: "6e41a0d4-02f0-4463-ab3a-114083375d19",
  TenantID: "3485b963-82ba-4a6f-810f-b5cc226ff898",
  DivisionID: "4236ABC4-8D01-45D2-9D97-459080BB6F7F",
  SharePoint_BaseUrl: "binusianorg.sharepoint.com/sites/ALESA/CDNASSETS/",
  Public_CDN: "https://api.apps.binus.ac.id/crr/",
  GoogleAnalytics: true,
  GoogleAnalyticsKey: "G-9FW54JSDBW",
  IsMaintenance: false,
};

export default Keys;
